import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Form, PublishersAndTagsSelect } from 'components';

interface FilterShape {
  publishers: number[];
  publisherTags: number[];
}

interface Props {
  publishers: { id: number; name: string }[];
  publisherTags: { id: number; name: string }[];
  filter: FilterShape;
  updateFilter: (changes: Partial<FilterShape>) => void;
}

const PublisherFilter = (props: Props) => {
  const { publishers, publisherTags, filter, updateFilter } = props;

  return (
    <Form.Field>
      <Form.Label bold>
        <FormattedMessage id="TrackingPublisherFilter__Label" />
      </Form.Label>

      <PublishersAndTagsSelect
        publishers={publishers}
        publisherTags={publisherTags}
        value={filter}
        onChange={updateFilter}
      />
    </Form.Field>
  );
};

export default PublisherFilter;
